import { render } from "./Main-Layout.vue?vue&type=template&id=a56df868"
import script from "./Main-Layout.vue?vue&type=script&lang=js"
export * from "./Main-Layout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__